module.exports = __webpack_public_path__ + "static/dog-with-wag-tag-mobile-1daf760b61131343fee52166aff27558.png";